import { render } from "./CJZSDetail.vue?vue&type=template&id=58a2c4a6&scoped=true"
import script from "./CJZSDetail.vue?vue&type=script&lang=js"
export * from "./CJZSDetail.vue?vue&type=script&lang=js"

import "./CJZSDetail.vue?vue&type=style&index=0&id=58a2c4a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a2c4a6"]])

export default __exports__